import {Button} from '@/components-v2/atoms'
import {AccordionItem} from '@/components-v2/molecules'

/**
 * Reusable accordion section for the Promotion Review screen.
 * @param {{
 *  label: string,
 *  children: import('react').ReactNode,
 *  onEdit?: () => void,
 *  showEdit?: boolean,
 * }} props
 */
export const PromotionReviewSection = ({label, children, onEdit, showEdit = true}) => {
  return (
    <AccordionItem
      size="large"
      expanded={true}
      label={<span className="font-medium">{label}</span>}
      rightAccessoryChild={
        showEdit && onEdit ? (
          <div
            className="ml-4"
            onClick={e => e.stopPropagation()}
            role="presentation"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation()
              }
            }}
          >
            <Button iconLeading="edit" size="small" variant="tertiary" text="Edit section" onClick={onEdit} />
          </div>
        ) : null
      }
    >
      {children}
    </AccordionItem>
  )
}
